// extracted by mini-css-extract-plugin
export default {"label":"FormControlLabel_label__V0-tY","asterisk":"FormControlLabel_asterisk__KEwjR"};